import WebFont from 'webfontloader';
import Utils from '../utils/utils';

const _callback = (callback0, callback1) => {
    return () => {
        if (typeof callback1 === 'function') callback1();
        callback0();
    };
};

const WebFontLoad = (params, doThat) => {
    return new Promise(resolve => {
        if (!doThat) {
            resolve(doThat);
            return;
        }

        const config = Utils.extend({}, params);

        config.active = _callback(() => {
            resolve(doThat);
        }, params.active);

        config.inactive = _callback(() => {
            resolve(doThat);
        }, params.inactive);

        WebFont.load(config);
    });
};

export {WebFontLoad};
